import { render, staticRenderFns } from "./declarationRequest.vue?vue&type=template&id=50975240&scoped=true&"
import script from "./declarationRequest.vue?vue&type=script&lang=js&"
export * from "./declarationRequest.vue?vue&type=script&lang=js&"
import style0 from "./declarationRequest.vue?vue&type=style&index=0&id=50975240&scoped=true&lang=css&"
import style1 from "./declarationRequest.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50975240",
  null
  
)

export default component.exports